const STORAGE_KEY = 'ewpUserToken'

const UserStorage = {
    setUserToken(usertoken) {
        localStorage.setItem(STORAGE_KEY, usertoken)
    },
    hasUserToken() {
        return (localStorage.getItem(STORAGE_KEY) != null)
    },
    getUserToken() {
        return localStorage.getItem(STORAGE_KEY)
    },
    clear() {
        localStorage.removeItem(STORAGE_KEY)
    }
}

export default UserStorage